<template>
  <div class="frame2_body">
    <div class="frame2">
      <div class="frame2_top">
        估值与分位
        <img src="../../../../public/img/shares_Info/close.png" alt="" @click="frame2_close"/>
      </div>
      <div class="frame2_content">
        <div class="frame2_content_title">市盈率PE(TTM)</div>
        <div class="frame2_content_text">
          【释义】：最新每股市价为最近12个月每股收益的倍数。反映了在每股盈利不变的情况下，当派息率为100%时及所得股息没有进行再投资的情况下，经过多少年投资可以通过股息全部收回的状态。一般情况下，市盈率越低的股票，表明投资价值越大。
        </div>
        <div class="frame2_content_text">
          【算法】：市盈率PE(TTM)=总市值/归属母公司股东的净利润TTM
        </div>
        <div class="frame2_content_text">【单位】：倍</div>
      </div>
      <div class="frame2_content">
        <div class="frame2_content_title">市净率PB（LF）</div>
        <div class="frame2_content_text">
          【释义】：普通股每股市价为每股净资产的倍数。PB越低，投资价值越高，适用于高风险、资产大量为实物资产的企业。
        </div>
        <div class="frame2_content_text">
          【算法】：市净率PB(LF)=总市值/指定最新公告股东权益（不含少数股东权益及优先股）
        </div>
        <div class="frame2_content_text">【单位】：倍</div>
      </div>
      <div class="frame2_content">
        <div class="frame2_content_title">市销率PS(TTM)</div>
        <div class="frame2_content_text">
          【释义】：每股市价为过去12个月每股营业收入的倍数。PS越低，投资价值越大。适用于销售成本较低的服务类行业，或者销售成本率趋同的传统行业的企业。
        </div>
        <div class="frame2_content_text">
          【算法】：市销率PS(TTM)=总市值/营业收入(TTM)
        </div>
        <div class="frame2_content_text">【单位】：倍</div>
      </div>
      <div class="frame2_content">
        <div class="frame2_content_title">市现率PCF（经营现金流TTM）</div>
        <div class="frame2_content_text">
          【释义】：每股市价为过去12个月每股经营性现金流的倍数。用于评价股票的价格水平和风险水平，市现率越小，表明上市公司的每股现金增加额越多，经营压力越小。
        </div>
        <div class="frame2_content_text">
          【算法】：市现率PCF（经营现金流TTM）=总市值/经营活动产生的现金流量(TTM)
        </div>
        <div class="frame2_content_text">【单位】：倍</div>
      </div>
      <div class="frame2_content">
        <div class="frame2_content_title">企业倍数EV/EBITDA</div>
        <div class="frame2_content_text">
          【释义】：企业倍数又称企业价值收益，是企业价值（剔除企业货币资金）与企业收益（扣除利息、税金、折旧和摊销前的收益）的比值，企业倍数估值包括债务，从潜在收购方的角度评估公司的价值。
        </div>
        <div class="frame2_content_text">
          【算法】：企业倍数EV/EBITDA=企业价值(总市值+带息债务-货币资金)/企业收益（息税折旧摊销前利润）
        </div>
        <div class="frame2_content_text">【单位】：倍</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    methods:{
        frame2_close(){
            this.$emit('frame2_close')
        }
    }
};
</script>

<style scoped>
.frame2_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame2 {
  width: 448px;
  height: 1240px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame2_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame2_content {
  margin-top: 28px;
}
.frame2_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame2_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame2_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>